<template>
  <div>
    <div class="clientCurrentBalance"><label>баланс {{clientCurrentBalance}}</label></div>

    <div class="newAddMoney">
      <div class="field has-addons">
        <div class="control">
          <input class="input sum" type="number" placeholder="sum" v-model="replenishBalanceSum">
          <a class="button is-info" v-on:click="replenishBalance" :disabled="!!loading">Пополнить</a>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-if="addMoneyPage && addMoneyPage.content">
      <label class="label addLabel">Пополнения</label>
      <table class="table is-bordered is-striped is-narrow campaignsTable">
        <thead>
        <tr>
          <th>
            <div :class="sortButtonClass('chargingTimestamp', 'asc')" class="sortButton" @click="changeSort('chargingTimestamp', 'asc')">{{ascIcon}}</div>
            <div :class="sortButtonClass('chargingTimestamp', 'desc')" class="sortButton" @click="changeSort('chargingTimestamp', 'desc')">{{descIcon}}</div>
            дата
          </th>
          <th>
            <div :class="sortButtonClass('sum', 'asc')" class="sortButton" @click="changeSort('sum', 'asc')">{{ascIcon}}</div>
            <div :class="sortButtonClass('sum', 'desc')" class="sortButton" @click="changeSort('sum', 'desc')">{{descIcon}}</div>
            сумма
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(money, index) in addMoneyPage.content">
          <td class="date">
            {{getDateFormat(money.chargingTimestamp < 1000000000000 ? money.chargingTimestamp*1000 : money.chargingTimestamp)}}
          </td>
          <td class="sum" >
            {{money.sum}}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="paging-bottom">
      <Paging :refresh="loadAddMoneyData" :per-page="perPage" :data.sync="addMoneyPage" :pagingClass="'bottom'"/>
    </div>
  </div>
</template>

<script>
  const BILLING_API = '/billing/money'

  import Paging from '../components/Paging'
  import VisCommon from '../components/VisCommon'

  export default {
    name: 'Balance',
    extends: VisCommon,
    components: {
      Paging
    },
    props: ['clientId', 'clientCurrentBalance', 'reloadClient'],
    data() {
      return {
        addMoneyPage: {content: []},
        perPage: 16,
        title: '',
        replenishBalanceSum: '',
        loading: false,

        currentSort: 'chargingTimestamp',
        currentSortDir: 'desc',
        ascIcon: ' ▲',
        descIcon: ' ▼'
      }
    },
    created: function () {
      this.loadAddMoneyData()
    },
    methods: {
      loadAddMoneyData(page) {
        let that = this
        this.loading = true
        page = page ? (page - 1) : 0
        let url = BILLING_API + '/getAddMoneyList/' + this.$props.clientId + '?page=' + page + '&pageSize=' + this.perPage + '&sortDir=' + this.currentSortDir + '&sort=' + this.currentSort
        this.$http.get(url, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            that.loading = false
            that.addMoneyPage = response.data
          })
          .catch((error) => {
            that.loading = false
            console.log(error)
            that.openNotificationWithType('danger', 'Ошибка загрузки списка пополнений. ')
          })
      },
      changeSort(s, dir) {
        if (!this.isSortCurrent(s, dir)) {
          this.currentSort = s
          this.currentSortDir = dir
          this.loadAddMoneyData()
        }
      },
      sortButtonClass(s, dir) {
        return this.isSortCurrent(s, dir) ? 'current' : ''
      },
      isSortCurrent(s, dir) {
        return s === this.currentSort && dir === this.currentSortDir
      },
      replenishBalance() {
        let that = this
        if (this.replenishBalanceSum) {
          this.loading = true
          let url = BILLING_API + '/addMoney/' + this.$props.clientId + '?sum=' + this.replenishBalanceSum
          this.$http.post(url, {}, {headers: this.prepareSecurityHeader()})
            .then((response) => {
              that.loading = false
              that.replenishBalanceSum = ''
              that.$props.reloadClient()
              that.loadAddMoneyData()
            })
            .catch((error) => {
              that.loading = false
              console.log(error)
              that.openNotificationWithType('danger', 'Ошибка пополнения баланса')
            })
        }
      }
    }
  }
</script>

<style scoped>
 .input.sum {
   max-width: 128px;

 }
  th div {
    display: inline-block;
  }
  th .sortButton {
    cursor: pointer;
  }
   th .sortButton:hover {
     font-weight: bold;
     font-size: large;
   }
   th .sortButton.current {
     font-weight: bold;
     font-size: large;
   }
  .addLabel {
    margin-bottom: -27px;
    margin-left: 4px;
    padding-top: 8px;
    width: 32px;
  }
  .clientCurrentBalance, .newAddMoney {
    display:inline-block;
  }
  .clientCurrentBalance {
    font-size: large;
    margin-right: 32px;
  }
</style>




// WEBPACK FOOTER //
// Balance.vue?de662f98